import {
  skipToken,
  useMutation,
  useQuery as useReactQuery,
} from "@tanstack/react-query";
import FetchClients from "../client";

const name = {
  useManualQuery,
  useQuery,
} as const;

export default name;

async function getName(id: number) {
  const { data } = await FetchClients.nominators.GET("/name", {
    params: { query: { id } },
    parseAs: "text",
  });
  if (data) return data;
}

const NOMINATOR_NAME_KEY = "nominator-name";
function useQuery(id?: number) {
  return useReactQuery({
    queryKey: [NOMINATOR_NAME_KEY, id],
    queryFn: typeof id === "number" ? () => getName(id) : skipToken,
    enabled: typeof id === "number",
  });
}

function useManualQuery() {
  return useMutation({
    mutationFn: async (id?: number | null) => {
      if (typeof id !== "number") return;
      return getName(id);
      // error is thrown/logged in IdentifyUserManager if this call fails or if no data is returned
    },
  });
}
